import React from 'react'
import PropTypes from 'prop-types'
import idGenerator from 'react-id-generator'
import classNames from 'classnames'
import { Link } from 'gatsby'

// Lets import styles for component
import './CountryChooser.sass'

export default function CountryChooser({ countries, activeCountry, t, l }) {
  return (
    <div>
      <div className="container">
        <div className="customeTitle">
          {t('home_country_chooser_title')}
        </div>
      </div>
      <div className="container">
        <div className="countriesWrap">
          {countries.map(country => {
            return (
              <Link 
                key={idGenerator()} 
                to={`/${l.i18n.language}/countries/${country.title.toLowerCase()}`}
                className={
                  classNames({
                    countryItem: true,
                    active: activeCountry.toLowerCase() === country.title.toLowerCase()
                  })
                }  
              >
                <div>
                  <div className="image">
                    <img src={country.image.publicURL} alt="country flag"/>
                  </div>
                  {l.i18n.language === 'ru' ? country.titleRu : country.title}
                </div>
              </Link>
            )
          })}
        </div>
      </div>
    </div>
  )
}

CountryChooser.propTypes = {
  countries: PropTypes.array.isRequired,
}
